export const SALE_STATUS = {
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled'
}
